import { render } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import TextTyping from './TextTyping';

// Text Typing
document.addEventListener('DOMContentLoaded', () => {
	const allTextTyping = document.querySelectorAll('.wp-block-ttb-text-typing');
	allTextTyping.forEach(textTyping => {
		const attributes = JSON.parse(textTyping.dataset.attributes);

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<TextTyping attributes={attributes} />
		</>, textTyping);

		textTyping?.removeAttribute('data-attributes');
	});
});